import NetworkHandler from 'utils/network';
import config from 'config';
import { message } from 'antd';

function exportBusStops(params = {}) {
    return NetworkHandler.get(`${config.getUrl('bus_stops')}/export`, {
        params,
    });
}

function getAnnounceFile(params) {
    return NetworkHandler.post(`${config.getUrl('get_announce_file')}`, {
        ...params,
    });
}
async function downloadAnnounceFile(params) {
    return await NetworkHandler.post(`${config.getUrl('download_announce_file')}`, {
        ...params,
    });
}

async function downloadAll({ routeId, lineId }) {
    return await NetworkHandler.post(`${config.getUrl('bus_route')}/${routeId}/lines/${lineId}/station/download`, {});
}

export default {
    getAnnounceFile,
    downloadAnnounceFile,
    downloadAll,
    exportBusStops,
};
